export default __webpack_public_path__ + "static/media/350.265f0139.png";